import RealtyType from './RealtyType';
import Description from './Description';
import DescriptionAndType from './DescriptionAndType';
import Area from './Area';
import Price from './Price';
import Date from './Date';
import Building from './Building';
import Land from './Land';
import Contacts from './Contacts';
import ContactsHidden from './ContactsHidden';

const AnnouncementGridColumns = {
  RealtyType,
  Description,
  DescriptionAndType,
  Area,
  Building,
  Land,
  Price,
  Contacts,
  ContactsHidden,
  Date
};

module.exports = AnnouncementGridColumns;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/index.js